import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { storageKeys } from 'config/settings.json';
import FrameComponent from 'components/FrameComponent';
import StorageHandler from 'config/StorageHandler';

const onLoad = () => {
  document.body.classList.add('no-scroll');

  document.body.classList.add('subApp');
  document.querySelector('nav').classList.add('subApp');
  document.querySelector('.backgroundImage').classList.add('subApp');
};

const live = 'https://academy.travpromobile.com';
// const demo = 'http://localhost:8081';

export default class SubApp extends Component {
  constructor(props) {
    super(props);

    const {
      appId, email, chapterId, pageId, type,
    } = props;

    this.state = {
      subAppUrl: `${live}/${type}/${appId}/${email}/${chapterId}/${pageId}/${true}/${true}`,
    };
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');

    document.body.classList.remove('subApp');
    document.querySelector('nav').classList.remove('subApp');
    document.querySelector('.backgroundImage').classList.remove('subApp');

    StorageHandler.remove(storageKeys.activeSubApp);
  }

  render() {
    const { subAppUrl } = this.state;

    return (
      <div className="subapp__view" style={{ position: 'fixed', zIndex: 20 }}>
        <FrameComponent
          onLoad={onLoad}
          src={subAppUrl}
          height="calc(100%)"
          width="calc(100%)"
        />
      </div>
    );
  }
}

SubApp.propTypes = {
  appId: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  chapterId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  pageId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  type: PropTypes.string,
};

SubApp.defaultProps = {
  type: 'training',
};
